module.exports = __webpack_public_path__ + "img/logo_viber.d26d5cbd.svg";